/**
 * @function pruneEmptyTmnts
 * @private
 * @description Identifies TextPair entries that contain 5 or more consecutive question marks
 * @param {string} _ - Unused key parameter
 * @param {Object} entry - The entry object to evaluate
 * @param {string} entry.__typename - The type name of the entry
 * @param {string} entry.value - The value of the entry to check against the pattern
 * @returns {boolean} True if the entry is a TextPair with 5+ consecutive question marks,
 *  false otherwise
 */
const pruneEmptyTmnts = (_, entry) => {
  const { __typename, value } = entry || {};
  // Regex to match 5 or more consecutive question marks
  const questionMarksPattern = /\?{5,}/;

  return __typename === 'TextPair' && questionMarksPattern.test(value);
};

/**
 * @function pruneFeatureFlags
 * @private
 * @description Identifies keys that contain "featureFlag" string
 * @param {string} key - The key to check
 * @returns {boolean} True if the key contains "featureFlag", false otherwise
 */
const pruneFeatureFlags = (key) => key.includes('featureFlag');

/**
 * @constant {Array<Function>} rules
 * @description Collection of pruning rules used to filter out specific entries
 * Each function should return true for entries that should be pruned
 */
const rules = [pruneEmptyTmnts, pruneFeatureFlags];

export default rules;
